export default {"src":"/_next/static/media/pillWithBox_24.0248202c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};